export default function initToggle() {
    const toggleTriggerElems = document.querySelectorAll('[data-toggle-element]');

    toggleTriggerElems.forEach((elem) => {
        const targetElem = document.querySelector(`[id="${elem.getAttribute('data-toggle-element')}"]`);
        const bodyOverlay = elem.getAttribute('data-toggle-body');

        function toggleBody() {
            document.body.toggleAttribute('data-overlay');
        }
        function toggleTarget() {
            elem.toggleAttribute('aria-expanded');
            targetElem.toggleAttribute('aria-hidden');
        }

        document.body.addEventListener('click', (e) => {
            if (e.currentTarget.hasAttribute('data-overlay')) {
                toggleTarget();
                toggleBody();
            }
        });

        elem.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            toggleTarget();

            if (bodyOverlay) {
                toggleBody();
            }
        });
    });
}
